"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: 'ココロオークション',
    organizationId: 'kQKxHJNJzmxJnqsU6o8Y',
    applicationKey: 'cocoroauction',
    applicationType: 'standalone',
    artistId: 'W9mHLUIUoUh1k3QQX3H5I4207b12',
    version: '1.0.0',
    ios: {
        bundleId: 'com.utoniq.cocoroauction',
        appId: '',
    },
    android: {
        bundleId: 'com.utoniq.cocoroauction',
    },
    deeplinkUrl: 'https://cocoroauction.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/3741083',
    deeplinkProd: 'cocoroauction.utoniq.com',
    custom: {
        modules: {
            membership: true,
            item: true,
            store: true,
            mission: true,
            cart: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: [],
        artistTabs: ['home', 'collections', 'posts', 'notifications', 'myProfile'],
    },
});
